import React, { useState, useEffect ,useContext} from "react";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { Card, Calendar, Avatar, List, Table, Progress } from "antd";
import VirtualList from "rc-virtual-list";
import {
	EditOutlined,
	EllipsisOutlined,
	SettingOutlined,
} from "@ant-design/icons";
import { UserContext } from "../../UserContext";
import { Link } from "react-router-dom";
import LoaderTeacher from "../../Loader/Loader_Teacher";

const { Meta } = Card;

const Profile = () => {
	const [loading, setLoading] = useState(false);
	const {studentapiuri,token} = useContext(UserContext);
	const [courses, setcourses] = useState({})
	const [analytics,setanalytics] = useState({})
	
	const Getcourses = async ( ) => {
		setLoading(true);
		
		const response = await fetch(`${studentapiuri}/stud/allcourses`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: "BEARER " + token,
			},
		});
		const data = await response.json();
		setcourses(data?.data);
		console.log(courses);
		setLoading(false);
	};
	const GetAnalytics = async ( ) => {
		setLoading(true);
		
		const response = await fetch(`${studentapiuri}/stud/analytics`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: "BEARER " + token,
			},
		});
		const data = await response.json();
		// setcourses(data?.data);
		console.log(data);
		setanalytics(data);
		setLoading(false);
	};

	
	useEffect(()=>{
		Getcourses();
		GetAnalytics();
	},[])

	if(loading){
		return(<LoaderTeacher loader_text={"fetching data"}></LoaderTeacher>)
	}

	
	return (
		<>
			<div className="section-1">
				<div className="Profile-section">
					<Card
						style={{
							minWidth: 300,
							maxWidth: 450,
							height: 325,
						}}>
						<Meta
							avatar={
								<Avatar
									src="https://xsgames.co/randomusers/avatar.php?g=pixel"
									style={{ width: "50px", height: "50px" }}
								/>
							}
							title="Mareedu Satyanarayana"
							description="20VV1A0529"
						/>
						<br />
						<div className="user-details">
							Degree&nbsp;
							<span>B.Tech</span>
						</div>
						<div className="user-details">
							Department&nbsp;
							<span>Computer Science and Engineering</span>
						</div>
						<div className="user-details">
							Email&nbsp;
							<span>mareedu.satyanarayana.5475@gmail.com</span>
						</div>
						<div className="user-details">
							Contact No&nbsp;
							<span>+91 8919502589</span>
						</div>
					</Card>
				</div>
				<div className="profile-course-details">
					<Card className="registered-courses" title="Registered Courses">
						{courses &&
							Object.keys(courses).map((course, i) => {
								return (
									courses[course].isRegistered && (
										<>
											<Link
												to={`/student/courses/${course}/module/1/submodule/1`}>
												{courses[course]?.data?.courseOn}
											</Link>
											<br></br>
										</>
									)
								);
							})}
					</Card>
					<Card title="Analytics">
						<h5>Enrolled Courses : {analytics.enrolled}</h5>
						<List
							className="instructor-course-list"
							grid={{ gutter: 16, column: 1 }}
							dataSource={analytics.progress}
							renderItem={(progress) => (
								<li>
									<div>{courses[progress.courseId]?.data?.courseOn}</div>
						
									<Progress type="dashboard" percent={progress.progress} />
								</li>
							)}
						/>
					</Card>
				</div>
			</div>
		</>
	);
};

export default Profile;
